module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-matthias.190810cf.jpeg";